import { useState } from 'react'
import { Eye, EyeOff, AlertCircle, Check } from 'lucide-react'
import { supabase } from '../lib/supabase'
import useAuthStore from '../store/authStore'
import { useT } from '../i18n/useT'

export default function ResetPasswordModal() {
  const t = useT()
  const [password, setPassword] = useState('')
  const [confirm, setConfirm]   = useState('')
  const [showPw, setShowPw]     = useState(false)
  const [error, setError]       = useState('')
  const [loading, setLoading]   = useState(false)
  const [done, setDone]         = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')

    if (password.length < 6) {
      setError(t('auth_err_pw_short'))
      return
    }
    if (password !== confirm) {
      setError(t('reset_err_mismatch'))
      return
    }

    setLoading(true)
    try {
      const { error } = await supabase.auth.updateUser({ password })
      if (error) throw error
      setDone(true)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  const handleClose = () => {
    useAuthStore.setState({ passwordRecovery: false })
  }

  if (done) {
    return (
      <div className="modal-overlay">
        <div className="modal-sheet" style={{ maxWidth: 400 }}>
          <div className="modal-handle" />
          <div style={{ padding: '32px 20px', textAlign: 'center' }}>
            <div className="auth-confirm-icon">
              <Check size={32} strokeWidth={1.5} />
            </div>
            <h2 style={{ margin: '0 0 8px', fontSize: '1.1rem' }}>{t('reset_done_title')}</h2>
            <p style={{ color: 'var(--text-2)', fontSize: '0.88rem', margin: '0 0 24px' }}>
              {t('reset_done_msg')}
            </p>
            <button className="btn btn-primary" style={{ width: '100%' }} onClick={handleClose}>
              {t('reset_done_btn')}
            </button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="modal-overlay">
      <div className="modal-sheet" style={{ maxWidth: 400 }}>
        <div className="modal-handle" />
        <div style={{ padding: '24px 20px' }}>
          <h2 style={{ margin: '0 0 4px', fontSize: '1.1rem' }}>{t('reset_title')}</h2>
          <p style={{ color: 'var(--text-2)', fontSize: '0.85rem', margin: '0 0 20px' }}>
            {t('reset_sub')}
          </p>

          <form onSubmit={handleSubmit}>
            {error && (
              <div className="form-error" style={{ marginBottom: 12 }}>
                <AlertCircle size={16} />
                {error}
              </div>
            )}

            <div className="form-group">
              <label>{t('reset_new_pw')}</label>
              <div className="input-password-wrap">
                <input
                  type={showPw ? 'text' : 'password'}
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder={t('auth_pw_hint')}
                  required
                  autoFocus
                  autoComplete="new-password"
                />
                <button type="button" className="input-password-eye" onClick={() => setShowPw(v => !v)} tabIndex={-1}>
                  {showPw ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>

            <div className="form-group">
              <label>{t('reset_confirm_pw')}</label>
              <div className="input-password-wrap">
                <input
                  type={showPw ? 'text' : 'password'}
                  value={confirm}
                  onChange={e => setConfirm(e.target.value)}
                  placeholder={t('reset_confirm_ph')}
                  required
                  autoComplete="new-password"
                />
              </div>
            </div>

            <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={loading}>
              {loading ? t('reset_saving') : t('reset_save')}
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}
